module.exports = __webpack_public_path__ + "img/download-on-apple.2b345d9e.png";